export default "__VITE_ASSET__BkzjyOx6__"